import { useEffect } from "react";
import { fetchUserInfo } from "../userInfo/userInfoSlice";
import { useDispatch, useSelector } from "react-redux";
import selectRumClient from "./rum";

export const InitializeRum = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserInfo());
  }, []);

  // Reference the rumClient to ensure that it gets instantiated
  useSelector(selectRumClient);

  return <></>;
};
